import { render, staticRenderFns } from "./dandelion-product-detail-item.vue?vue&type=template&id=5bacdc56&scoped=true&"
import script from "./dandelion-product-detail-item.vue?vue&type=script&lang=js&"
export * from "./dandelion-product-detail-item.vue?vue&type=script&lang=js&"
import style0 from "./dandelion-product-detail-item.vue?vue&type=style&index=0&id=5bacdc56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bacdc56",
  null
  
)

export default component.exports